(ns app.front.view.fee.subs
  (:require [app.front.entities :as entities]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::payment-methods
  (fn [[_ authority-group-id]]
    (rf/subscribe [::entities/entities {:domain/authority-group authority-group-id
                                        :entity/type            :entity.type/payment-method}]))
  (fn [payment-methods _]
    payment-methods))

(rf/reg-sub ::online-payment-method
  (fn [[_ group-id]]
    (rf/subscribe [::payment-methods group-id]))
  (fn [payment-methods _]
    (->> payment-methods
         (filter #(and (= (:payment-method/type %) :payment-method/online-card)
                       (not (:payment-method/disabled? %))))
         first)))
